var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { stylePropType, TSS_DARK_BLUE, TSS_BLACK, TSS_BLUE } from 'tss-core-lib-common';

import Checkbox from '../Checkbox';
import Loading from '../Loading';
import FadeOut from '../FadeOut';
import { ColumnShape, DataRowShape } from './TableCommon';
import Row from './Row';
import Header from './Header';
import './table.css';

var styles = void 0;

var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: ''
    }, _this.onClick = function (props) {
      return function () {
        return props.onSort && props.onSort(props.id, !props.sortDesc);
      };
    }, _this.selectAll = function () {
      _this.setState({ allSelected: !_this.state.allSelected });
      return !_this.state.allSelected;
    }, _this.deSelectAll = function () {
      _this.setState({ allSelected: false });
    }, _this.renderRows = function (rowData, columns, getRowStyle, getExpandedRowContent, getRowSelectable, onSelect, onExpandChange) {
      return _this.props.data.map(function (row) {
        return React.createElement(
          Row,
          {
            key: row.id,
            id: row.id,
            style: getRowStyle ? getRowStyle(row) : null,
            columns: columns,
            rowData: row,
            expandable: Boolean(getExpandedRowContent),
            selectable: getRowSelectable && getRowSelectable(row),
            showSelectCell: Boolean(onSelect),
            rowDisabled: row.rowDisabled,
            rowDisabledReason: row.rowDisabledReason,
            onSelectChange: onSelect,
            onExpandChange: onExpandChange
          },
          getExpandedRowContent && row.expanded ? getExpandedRowContent(row) : null
        );
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Table, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var atLeastOneHeader = this.props.columns.some(function (_ref2) {
        var label = _ref2.label,
            labelKey = _ref2.labelKey;
        return label || labelKey;
      });
      return React.createElement(
        'div',
        { className: css(styles.container) },
        atLeastOneHeader ? React.createElement(
          'div',
          { className: css(styles.headerContainer) },
          this.props.columns.map(function (column) {
            return column.label || column.labelKey || column.render ? React.createElement(Header, Object.assign({ key: column.id }, column)) : React.createElement('div', {
              key: column.id,
              className: css(styles.column, styles.placeholderHeader, column.style)
            });
          }),
          !this.props.onSelect && this.props.data.some(function (_ref3) {
            var url = _ref3.url;
            return url;
          }) ? React.createElement('div', { className: css(styles.navArrowContainer) }) : null,
          this.props.onAllSelect && this.props.onSelect ? React.createElement(
            'div',
            { className: css(styles.selectContainer) },
            React.createElement(Checkbox, {
              checked: this.state.allSelected,
              onChange: this.props.onAllSelect
            })
          ) : null,
          !this.props.onAllSelect && this.props.onSelect ? React.createElement('div', { className: css(styles.selectContainer) }) : null,
          this.props.onExpandChange && this.props.getExpandedRowContent ? React.createElement('div', { className: css(styles.navArrowContainer) }) : null
        ) : null,
        this.props.recentChangedData && this.props.recentChangedData.length ? React.createElement(
          'div',
          { className: css(styles.focusedDataDivider) },
          (this.props.recentChangedData || []).map(function (rowData) {
            return React.createElement(
              Row,
              {
                key: rowData.id,
                id: rowData.id,
                style: _this2.props.focusRowStyle !== null ? _this2.props.focusRowStyle : null,
                columns: _this2.props.columns,
                rowData: rowData,
                expandable: Boolean(_this2.props.getExpandedRowContent),
                selectable: _this2.props.getRowSelectable && _this2.props.getRowSelectable(rowData),
                showSelectCell: Boolean(_this2.props.onSelect),
                onSelectChange: _this2.props.onSelect,
                onExpandChange: _this2.props.onExpandChange
              },
              _this2.props.getExpandedRowContent && rowData.expanded ? _this2.props.getExpandedRowContent(rowData) : null
            );
          })
        ) : null,
        React.createElement(
          'div',
          { className: css(styles.rowContainer) },
          this.renderRows(this.props.data, this.props.columns, this.props.getRowStyle, this.props.getExpandedRowContent, this.props.getRowSelectable, this.props.onSelect, this.props.onExpandChange)
        ),
        this.props.loading ? React.createElement(
          'div',
          { className: css(styles.loadingContainer) },
          React.createElement(
            FadeOut,
            null,
            React.createElement(Loading, { fill: true })
          ),
          ';'
        ) : null
      );
    }
  }]);

  return Table;
}(Component);

Table.propTypes = {
  loading: PropTypes.bool,
  columns: PropTypes.arrayOf(ColumnShape).isRequired,
  data: PropTypes.arrayOf(DataRowShape).isRequired,
  recentChangedData: PropTypes.arrayOf(DataRowShape),
  allSelected: PropTypes.bool,
  getRowStyle: PropTypes.func,
  focusRowStyle: stylePropType,
  getRowSelectable: PropTypes.func,
  getExpandedRowContent: PropTypes.func,
  onSelect: PropTypes.func,
  onAllSelect: PropTypes.func,
  onExpandChange: PropTypes.func
};
Table.defaultProps = {
  loading: false,
  recentChangedData: [],
  allSelected: false,
  getRowStyle: null,
  focusRowStyle: null,
  getRowSelectable: null,
  getExpandedRowContent: null,
  onSelect: null,
  onAllSelect: null,
  onExpandChange: null
};

styles = StyleSheet.create({
  container: {
    flex: '1 0 auto',
    position: 'relative'
  },

  headerContainer: {
    display: 'flex',
    borderBottom: '1px solid ' + TSS_DARK_BLUE(0.05)
  },

  header: {
    fontSize: '1.2rem',
    color: TSS_BLACK(),
    textTransform: 'uppercase',
    padding: '1.3rem 1.2rem 1.1rem 1.2rem',
    display: 'flex',
    alignItems: 'flex-end'
  },

  placeholderHeader: {},

  sortableHeader: {
    cursor: 'pointer',

    ':hover > .tss-table__sorting-arrow': {
      opacity: 1
    },

    ':hover': {
      backgroundColor: 'rgba( 255, 255, 255, 0.7 )'
    }
  },

  column: {
    flex: '1 1 1%',

    ':first-child': {
      paddingLeft: '2.4rem'
    }
  },

  rowWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    borderBottom: '2px solid ' + TSS_DARK_BLUE(0.05)
  },

  rowChildren: {
    borderTop: '1px solid ' + TSS_DARK_BLUE(0.05)
  },

  expandableRowWrapper: {
    cursor: 'pointer'
  },

  row: {
    backgroundColor: 'white',
    display: 'flex',
    color: TSS_BLACK(),
    outline: 0
  },

  rowLink: {
    textDecoration: 'none',
    color: TSS_BLACK(),

    ':active': {
      backgroundColor: TSS_BLUE(0.15)
    }
  },

  cell: {
    padding: '1.5rem 2rem 1.5rem 1.2rem',
    color: TSS_BLACK(),
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },

  centeredCell: {
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center'
  },

  navArrowContainer: {
    width: '4rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0 0 0 1rem'
  },

  selectContainer: {
    width: '5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0 0 0 1rem'
  },

  sortingArrow: {
    opacity: 0
  },

  activeSortingArrow: {
    opacity: 1
  },

  loadingContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: 'rgba(255,255,255,0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  focusedDataDivider: {
    position: 'relative',
    width: '100%',
    borderBottom: '2px solid rgba(49, 46, 81, 0.10)',
    display: 'block',
    backgroundColor: 'white',
    marginBottom: '2rem'
  }
});

export default Table;